export enum EEnguiryTemplateType {
    DEALER = 'dealer_enquiry',
    RESPONSE = 'enquiry_response',
    STOCK_CUSTOMER = 'stock_enquire_customer',
    STOCK_DEALER = 'stock_enquire_dealer'
}
